/**
 * Runtime-safe product attribute key constants.
 *
 * Why this exists: Prisma's browser-generated client (`index-browser.js`)
 * only exports enums that are referenced in query filters. `ProductAttribute`
 * isn't in that list, so `import { ProductAttribute } from '@prisma/client'`
 * resolves to `undefined` in client bundles — any `ProductAttribute.COLOR`
 * access at runtime throws `Cannot read properties of undefined`.
 *
 * Use this constant in client components/stores instead of `ProductAttribute`.
 * Values intentionally match the Prisma enum string values.
 */
export const ProductAttributeKey = {
  COLOR: 'COLOR',
  LENGTH: 'LENGTH',
  WIDTH: 'WIDTH',
  HEIGHT: 'HEIGHT',
  PRICE_PER: 'PRICE_PER',
  ROLL_LENGTH: 'ROLL_LENGTH',
  ROLL_PRICE: 'ROLL_PRICE',
  PRICE_BREAKS: 'PRICE_BREAKS'
} as const

export type ProductAttributeKeyType = typeof ProductAttributeKey[keyof typeof ProductAttributeKey]
